import "./importers/jquery";
import {} from "../../vendor/assets/javascripts/jquery-ujs";

import "../../vendor/assets/javascripts/jquery-ui/accordion";
import "../../vendor/assets/javascripts/jquery-ui/datepicker";
import "../../vendor/assets/javascripts/jquery-ui/slider";
import "../../vendor/assets/javascripts/jquery-ui/tabs";
import "../../vendor/assets/javascripts/jquery-ui/draggable";
import "../../vendor/assets/javascripts/jquery-ui/resizable";
import "../../vendor/assets/javascripts/jquery-ui/droppable";
import "../../vendor/assets/javascripts/jquery-ui/tooltip";
import "../../vendor/assets/javascripts/jquery-ui/sortable";
import "../../vendor/assets/javascripts/jquery-ui/autocomplete";

import "../../vendor/assets/javascripts/bootstrap";
import "./importers/moment";
import "../../vendor/assets/javascripts/daterangepicker";
import "../../vendor/assets/javascripts/tablesort";
import "./importers/clipboard";
import "../../vendor/assets/javascripts/fleximages";
import "../../vendor/assets/javascripts/selectize";
